import { GetFunction, PostFunction } from "src/utils/axios_connection";
import UrlApi from "src/utils/Url";

// A customer's conversations with Ask Safrati. Both calls throw on failure
// after the toast.

// [{ id, title, createdAt, updatedAt }]
export const getSessions = (userId, dispatch) =>
  GetFunction({ Route: `${UrlApi.ai_chat.sessions}?userId=${encodeURIComponent(userId)}`, dispatch });

// One page of messages, oldest first. page counts from 0.
export const PAGE_SIZE = 50;
export const getSessionMessages = (sessionId, page, dispatch) =>
  PostFunction({
    Route: `${UrlApi.ai_chat.messages}?page=${page}&rowsPerPage=${PAGE_SIZE}`,
    data: { session_id: sessionId },
    isMultipart: false,
    showalert: false,
    dispatch,
  });

// The customer, for the page header. There is no "get one customer" call, so
// read the customer list a page at a time until they turn up (dev has under
// a hundred). Resolves to null when they cannot be found; never throws.
const CUSTOMERS_PAGE = 200;
const MAX_PAGES = 25;
export async function findCustomer(userId, dispatch) {
  const id = Number(userId);
  try {
    for (let page = 0; page < MAX_PAGES; page += 1) {
      // eslint-disable-next-line no-await-in-loop
      const response = await PostFunction({
        Route: UrlApi.clients.get,
        data: { page, rowsPerPage: CUSTOMERS_PAGE },
        isMultipart: false,
        showalert: false,
        dispatch,
      });
      const rows = Array.isArray(response?.data) ? response.data : [];
      const found = rows.find((row) => Number(row.id) === id);
      if (found) return found;
      if (rows.length < CUSTOMERS_PAGE) return null;
    }
  } catch {
    /* the header falls back to the customer number */
  }
  return null;
}
